export default "__VITE_ASSET___iRnf8ax__"